import React, { useEffect, useState } from 'react';
import classes from "./Policy.module.css";
import Header from '../components/Header';
import BottomNavbar from '../components/BottomNavbar';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from "react-icons/fa6";
import { useTranslation } from 'react-i18next';

import policyEn from "../locales/policies/policy.en.json";
import policyFr from "../locales/policies/policy.fr.json";
import policyAr from "../locales/policies/policy.ar.json";
import policyPg from "../locales/policies/policy.pg.json";
import policySwc from "../locales/policies/policy.swc.json";
import policyAm from "../locales/policies/policy.am.json";
import policyEs from "../locales/policies/policy.es.json";
import policySn from "../locales/policies/policy.sn.json";
import policyTp from "../locales/policies/policy.tp.json";
import policyKg from "../locales/policies/policy.kg.json";
import policyId from "../locales/policies/policy.id.json";
import policyKm from "../locales/policies/policy.km.json";
import policyRu from "../locales/policies/policy.ru.json";
import policyOm from "../locales/policies/policy.om.json";
import { useSelector } from 'react-redux';

const languageMap = new Map([
  ["0", policyEn],
  ["1", policyEn],
  ["2", policyEn],
  ["3", policyEn],
  ["4", policyEn],
  ["5", policyEn],
  ["6", policyEn],
  ["7", policyEn],
  ["8", policyEn],
  ["9", policyEn],
  ["10", policyEn],
  ["11", policyEn],
  ["12", policyEn],
  ["13", policyEn],
]);

const Policy = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [policy, setPolicy] = useState({});

  const { selectedLanguage } = useSelector(state => state.languageSlice);


  useEffect(() => {
    const mappedPolicy = languageMap.get(selectedLanguage);

    if (mappedPolicy) {
      setPolicy(mappedPolicy);
    } else {
      setPolicy(languageMap.get("1"));
    }
  }, [selectedLanguage]);

  return (
    <>
      <Header />

      <div className={classes.container}>

        <div className={classes.header_section}>
          <div className={classes.back_button} onClick={() => {
            navigate(-1);
          }}>
            <FaArrowLeft className={classes.back_icon} />
          </div>

          <h2 className={classes.header_text}>{t("22")}</h2>
        </div>

        {policy?.subheadings?.map(section => (
          <div key={section.id} className={classes.policy}>
            <h6 className={classes.policy_heading}>
              {section.id}. {section.title}
            </h6>
            {section.subheadings.map(subsection => (
              <p key={subsection.id} className={classes.policy_text}>
                <span>{subsection.id ? `${subsection.id}. ` : ""}</span><span>{subsection.content}</span>
              </p>
            ))}
          </div>
        ))}

      </div>
      <BottomNavbar active={4} />
    </>

  )
}

export default Policy